/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkspaceAnalytics } from './WorkspaceAnalytics';
import {
    WorkspaceAnalyticsFromJSON,
    WorkspaceAnalyticsFromJSONTyped,
    WorkspaceAnalyticsToJSON,
    WorkspaceAnalyticsToJSONTyped,
} from './WorkspaceAnalytics';

/**
 * 
 * @export
 * @interface WorkspaceAnalyticsResponse
 */
export interface WorkspaceAnalyticsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceAnalyticsResponse
     */
    success: boolean;
    /**
     * 
     * @type {WorkspaceAnalytics}
     * @memberof WorkspaceAnalyticsResponse
     */
    data: WorkspaceAnalytics;
}

/**
 * Check if a given object implements the WorkspaceAnalyticsResponse interface.
 */
export function instanceOfWorkspaceAnalyticsResponse(value: object): value is WorkspaceAnalyticsResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function WorkspaceAnalyticsResponseFromJSON(json: any): WorkspaceAnalyticsResponse {
    return WorkspaceAnalyticsResponseFromJSONTyped(json, false);
}

export function WorkspaceAnalyticsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceAnalyticsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'data': WorkspaceAnalyticsFromJSON(json['data']),
    };
}

export function WorkspaceAnalyticsResponseToJSON(json: any): WorkspaceAnalyticsResponse {
    return WorkspaceAnalyticsResponseToJSONTyped(json, false);
}

export function WorkspaceAnalyticsResponseToJSONTyped(value?: WorkspaceAnalyticsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': WorkspaceAnalyticsToJSON(value['data']),
    };
}

